/*
 *
 * AmbassadorsSummary reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_AMBASSADORS_SUMMARY_WATCHER,
  GET_AMBASSADORS_SUMMARY_SUCCESS,
  GET_AMBASSADORS_SUMMARY_FAILED,
  SAVE_EXCEL_AMBASSADORS_PROGRESS,
  SAVE_EXCEL_AMBASSADORS_WATCHER,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
} from "./constants"

export const initialState = fromJS({
  languages: [],
  isLoadingLanguage: true,
})

function ambassadorsSummaryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LANGUAGE_WATCHER:
      return state.set("isLoadingLanguage", true)
    case GET_LANGUAGE_SUCCESS:
      return state
        .set("languages", action.payload)
        .set("isLoadingLanguage", false)
    case GET_LANGUAGE_FAILED:
      return state.set("isLoadingLanguage", false).set("languages", [])
    case SAVE_EXCEL_AMBASSADORS_WATCHER:
      return state.set("percentage", 0)
    case SAVE_EXCEL_AMBASSADORS_PROGRESS:
      return state.set("percentage", action.payload)

    case GET_AMBASSADORS_SUMMARY_WATCHER:
      return state.set("isLoadingSummary", true).set("summary", [])
    case GET_AMBASSADORS_SUMMARY_SUCCESS:
      return state.set("isLoadingSummary", false).set("summary", action.payload)
    case GET_AMBASSADORS_SUMMARY_FAILED:
      return state.set("isLoadingSummary", false).set("summary", [])
    default:
      return state
  }
}

export default ambassadorsSummaryReducer
